<template>
	<div>
		<el-container class="footer">
			<el-footer class="content" height="100%">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-image style="width: 190px; height: 56px" :src="footerY"></el-image>
					</el-col>
					<el-col :span="4">
						<h4> {{ $t("menu.business") }}</h4>
						<ul>
							<router-link to="/RubberMaterial">
								<li>{{ $t("menu.Rubber") }} </li>
							</router-link>
							<router-link to="/PlasticMaterials">
								<li>{{ $t("menu.PlasticMaterials") }}</li>
							</router-link>
							<router-link to="/Oring">
								<li>{{ $t("menu.OXinQuan") }}</li>
							</router-link>
						</ul>
					</el-col>
					<el-col :span="4">
						<h4>{{ $t("menu.New") }}</h4>
						<ul>
							<router-link to="/CompanyDnamic">
								<li>{{ $t("menu.CompanyDnamic") }}</li>
							</router-link>
							<router-link to="/IndustryInformation">
								<li>{{ $t("menu.IndustryInformation") }}</li>
							</router-link>
						</ul>
					</el-col>

					<el-col :span="4">
						<h4>{{ $t("menu.Team") }}</h4>
						<ul>
							<router-link to="/LaboratoryCenter">
								<li>{{ $t("menu.LaboratoryCenter") }} </li>
							</router-link>
							<router-link to="/Recruitment">
								<li>{{ $t("menu.Recruitment") }}</li>
							</router-link>
						</ul>
					</el-col>
				</el-row>
			</el-footer>
			<!-- 横线 -->
			<el-row type="flex" justify="center">
				<el-col :span="20">
					<el-divider></el-divider>
				</el-col>
			</el-row>

			<!-- 底部 -->
			<div class="content">
				<el-row>
					<div v-for="(item,index) in ProjectList" :key="index">
						<el-col :span="5" :offset="1">
							<h4>{{item.region}}</h4>
							<ul>
								<li>{{ $t("menu.tel") }}<span>{{item.tel}}</span></li>
								<li>{{ $t("menu.fax") }}<span>{{item.fax}}</span></li>
								<li>{{ $t("menu.mailbox") }}<span>{{item.mailbox}}</span></li>
								<li>{{ $t("menu.companyAddress") }}<span>{{item.companyAddress}}</span></li>
								<li>{{ $t("menu.businessHours") }}<span>{{item.businessHours}}</span></li>
							</ul>
						</el-col>
					</div>

					<el-col :span="3" :offset="5">
						<h4>{{ $t("menu.SweepYardsAttention") }}</h4>
						<el-image style="width: 89px; height: 89px" :src="footerE"></el-image>

						<div style="color: #666666; font-size: 14px;margin-top:5px">
							{{ $t("menu.WeChatOfficialAccount") }}</div>
					</el-col>
					<el-col :span="1"><a href=" https://www.facebook.com/sealtech.aviation/">
							<el-image style="width: 40px; height: 40px" :src="footerS"></el-image>
						</a> </el-col>
					<el-col :span="1"> <a href="https://www.instagram.com/sealtech.hk/?hl=zh-tw">
							<el-image style="width: 40px; height: 40px" :src="footerSI"></el-image>
						</a> </el-col>
					<el-col :span="1"> <a href="https://mp.weixin.qq.com/s/PydYY2LffpBNdkVyn-lunQ">
							<el-image style="width: 40px; height: 40px" :src="footerWu"></el-image>
						</a></el-col>
					<el-col :span="1"> <a href="https://www.youtube.com/channel/UC8hiMG8f9rFakGI_ks8CZOA">
							<el-image style="width: 40px; height: 40px" :src="footerLiu"></el-image>
						</a></el-col>
				</el-row>
			</div>

		</el-container>
	</div>
</template>



<style scoped lang="less">
	h4 {
		margin-top: 0px;
		color: #f9fafc;
		font-size: 13px;
		font-weight: bold;
	}

	ul {
		list-style: none;
		padding: 0px;
		color: #666666;
		font-size: 14px;
		// line-height: 20px;
	}

	ul li {
		line-height: 25px;
		display: block;
		color: #666666;

	}

	ul a>li:hover {
		color: #f9fafc;
	}

	/deep/ a {
		text-decoration: none;
	}

	/deep/ .router-link-active {
		font-weight: normal;
	}
</style>

<script>
	export default {
		name: "Footer",

		data() {
			return {

				// 
				ProjectList: [],
				title: "",
				footerY: require("@/assets/images/footer/logo2.png"),
				footerE: require("@/assets/images/footer/qrcode.jpg"),

				footerS: require("@/assets/images/footer/facebook.svg"),
				footerSI: require("@/assets/images/footer/instagram.svg"),
				footerWu: require("@/assets/images/footer/wechat.svg"),
				footerLiu: require("@/assets/images/footer/youtube.svg"),
			};
		},
		created: function() {



			if (this.$i18n.locale == "TC") {
				this.title = "TC";
			} else if (this.$i18n.locale == "EN") {
				this.title = "EN";
			} else if (this.$i18n.locale == "SC") {
				this.title = "SC";
			}
			this.getSelectRubber()
		},
		methods: {
			async getSelectRubber() {
				const {
					data: res
				} = await this.$http.get(
					"/ContactUs/GetContactInfo", {
						params: {
							languageType: this.title
						},
					}
				);

				if (res.code !== 200) return console.log("数据请求失败! ");

				this.ProjectList = res.data;
				// console.log(this.ProjectList)
			},
		},
	};
</script>
